<template>
	<div>
		<div class="content">
			<p class="text">申请书封皮</p>
			<el-form
				:model="formData"
				:rules="rules"
				ref="formData"
				class="demo-ruleForm"
			>
				<el-row type="flex" class="row-bg" justify="space-between">
					<el-col :span="11">
						<el-form-item label="企业名称" prop="companyName" label-width="40%">
							<el-input
								:maxlength="inputMax"
								v-model="formData.companyName"
								disabled
								placeholder="请填写"
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item
							label="企业所在区域"
							prop="companyScale"
							label-width="40%"
						>
							<el-input
								:maxlength="inputMax"
								v-model="formData.companyScale"
								disabled
								placeholder="请填写"
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item
							label="版本号"
							prop="envelopeVersion"
							label-width="40%"
						>
							<el-input
								:maxlength="inputMax"
								v-model="formData.envelopeVersion"
								placeholder="1.0"
							></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="11">
						<el-form-item
							label="认定机构"
							prop="authOrganization"
							label-width="40%"
						>
							<el-input
								:maxlength="inputMax"
								v-model="formData.authOrganization"
								placeholder="请填写"
								disabled
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item
							label="申请时间"
							prop="approvalTime"
							label-width="40%"
						>
							<el-date-picker
								:editable="false"
								value-format="yyyy-MM-dd"
								:picker-options="pickerOptions"
								v-model="formData.approvalTime"
								placeholder="请选择"
							></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<el-row type="flex" justify="center" class="button_box">
			<el-col :span="6">
				<el-button type="primary" round @click="classSubmitForm(1)"
					>保存</el-button
				>
			</el-col>
			<el-col :span="6">
				<el-tooltip class="item" effect="light" content="操作点击上方步骤导航栏可跳转至对应页面填写信息" placement="top">
					<el-button round @click="classSubmitForm(2)">下一步</el-button>
				</el-tooltip>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { applicationCoverQuery, applicationCoverSave } from "@/api/ChinaHigh";
import { commonGetCompanyInfo } from "@/api/toolCommon";

export default {
	name: "applicationForm",
	props: {
		id: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			formData: {},
			rules: {
				// companyName: [ {required: true, message: "请输入企业名称", trigger: "blur"} ],
				// companyScale: [ {required: true, message: "请输入企业所在区域", trigger: "blur"} ],
				envelopeVersion: [
					{ required: true, message: "请输入版本号", trigger: "blur" }
				],
				// authOrganization: [ {required: true, message: "请输入认定机构", trigger: "blur"} ],
				approvalTime: [
					{ required: true, message: "请选择申请时间", trigger: "change" }
				]
			},
			//日期限制
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now() - 8.64e6;
				}
			}
		};
	},
	created() {
		this.chushi();
	},
	methods: {
		chushi() {
			this.formData = {};
			applicationCoverQuery(this.id).then(res => {
				if (res.data !== null && res.data !== "") {
					this.$set(this.formData, "envelopeVersion", res.data.envelopeVersion);
					this.$set(this.formData, "approvalTime", res.data.approvalTime);
					this.$set(
						this.formData,
						"authOrganization",
						res.data.authOrganization
					);
					this.$set(this.formData, "companyName", res.data.companyName);
					this.$set(this.formData, "companyScale", res.data.companyScale);
				}
			});
			commonGetCompanyInfo().then(res => {
				this.formData.companyName = res.data.name;
				this.formData.companyScale = res.data.reg_location;
				this.formData.authOrganization = res.data.reg_institute;
				this.$forceUpdate();
			});
		},
		classSubmitForm(status) {
			this.$refs["formData"].validate(valid => {
				if (valid) {
					this.formData.approvalId = this.id;
					console.log(this.formData);
					applicationCoverSave(this.formData).then(res => {
						if (res.code === "00000") {
							this.msgSuccess(res.msg);
							if (status === 2) {
								this.$emit("step", 11);
							}
						}
					});
				} else {
					return false;
				}
			});
		}
	}
};
</script>

<style scoped>
.flex .el-button {
	margin-bottom: 10px;
}
.button_box {
	margin-top: 20px;
}
.button_box button {
	padding: 10px 60px;
}
.image {
	width: 100%;
	height: auto;
}
.select_box {
	display: flex;
	justify-content: space-between;
}
.select_box .el-select {
	width: 30% !important;
}
.textarea {
	width: 90%;
	height: 164px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	resize: none;
}

.wrap {
	width: 84%;
	margin-left: 16%;
}

.row-bg {
	width: 84%;
	margin: 0 auto;
	flex-wrap: wrap;
}

.content {
	margin-top: 30px;
	background: #fff;
	width: 100%;
}
.content .text {
	font-size: 13px;
	padding: 10px 20px;
	border-bottom: 1px solid #d4d4d4;
	position: relative;
}
.content .text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
.el-table .cell {
	white-space: pre-line;
}
.el-select {
	width: 100%;
}
</style>
